module.exports = __webpack_public_path__ + "media/deny2.13045217.webm";